import { render, staticRenderFns } from "./profile-settings.vue?vue&type=template&id=4a3571a0&scoped=true"
import script from "./profile-settings.vue?vue&type=script&lang=ts"
export * from "./profile-settings.vue?vue&type=script&lang=ts"
import style0 from "./profile-settings.vue?vue&type=style&index=0&id=4a3571a0&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3571a0",
  null
  
)

export default component.exports